<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <!-- begin                                                                         -->
    <v-card v-if="proceed_flag" align="center" justify="center" class="box">
      <!-- <v-card-title> Add Visitor </v-card-title> -->
      <v-toolbar flat dense class="toolbar">
        <v-toolbar-title>Add Visitor</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-img style="width: 250px; height: 155px" class="shrink mr-2" contain :src="logo"></v-img>
          </v-col>
          <!-- <v-col cols="12" v-if="qrcode==true">
               <qrcode-vue v-if="visitor_mobileno!=null" :value="visitor_mobileno" :size="100" level="H" />
            </v-col> -->
        </v-row>
        <v-row>
          <v-col cols="12" md="4" sm="4"></v-col>
          <v-col cols="12" md="3" sm="3">
            <v-text-field v-model="visitor_mobileno" append-icon="mdi-cellphone-basic" label="*Mobile No." single-line
              dense hint="Enter your mobileno" persistent-hint id="mobilenumber"></v-text-field>
            <span id="messages"> </span>
            <div v-if="mob_error == true" class="alert">{{ mob_error1 }}</div>
          </v-col>
          <v-col cols="12" md="1" sm="1">
            <v-btn color="info" @click="getVisitor">Fetch</v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="4" sm="4"></v-col>
          <v-col cols="12" md="4" sm="4">
            <v-text-field v-model="visitor_name" append-icon="mdi-account" label="*Name" dense single-line
              hint="Enter your name" persistent-hint :rules="textRule" @keyup="validName"></v-text-field>
            <div v-if="name_error == true" class="alert">{{ error }}</div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="4" sm="4"></v-col>
          <v-col cols="12" md="4" sm="4">
            <v-text-field v-model="visitor_email" append-icon="mdi-email" label="Email" dense single-line
              hint="Enter your Email" persistent-hint :rules="[rules.email]"></v-text-field>
            <!-- <div> -->
            <!-- <input type="text" @keyup="checkValue" v-model="visitor_name" /> -->
            <div v-if="name_error == true" class="alert">{{ error }}</div>

            <!-- </div> -->
          </v-col>

        </v-row>
        <v-row>
          <v-col cols="12" md="4" sm="4"></v-col>
          <v-col cols="12" md="4" sm="4">
            <v-textarea outlined name="input-7-4" hint="Enter your address" persistent-hint
              append-icon="mdi-city-variant-outline" v-model="visitor_address" label="Address"></v-textarea>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="4" sm="4"></v-col>
          <v-col cols="12" md="4" sm="4" v-if="name_error == false && mob_error == false">
            <v-btn color="info" :disabled="isSaveButtonDisabled" @click="addVisitor">Add Myself
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
// import QrcodeVue from 'qrcode.vue'
export default {
  // components: {
  //   QrcodeVue,
  // },
  data: () => ({
    textRule: [(v) => !!v || "Field is required"],
    rules: {
      required: value => !!value || 'Required.',
    },

    snackbar_msg: "",
    color: "",
    snackbar: false,
    overlay: false,
    visitor_email: null,
    ///////////////////////////////////////////////
    logo: null,
    proceed_flag: false,
    visitor_address: null,
    visitor_name: null,
    visitor_mobileno: null,
    visitor_present: false,
    // save_edit: "Add Myself",
    name_error: false,
    mob_error: false,
    ///////////////////
    // qrcode:false,
  }),

  computed: {
    isSaveButtonDisabled() {
      return !(
        this.visitor_name !== null &&
        this.visitor_mobileno &&
        this.visitor_address
      );
    },
  },

  mounted() {
    // this.save_edit = "Add Myself";

    console.log("params", this.$route.query.o); // outputs 'yay'
    console.log("params", this.$route.query.t); // outputs 'yay'
    //  return
    const formdata = {
      o: this.$route.query.o,
      t: this.$route.query.t,
    };
    //alert(formdata.o)
    this.overlay = true;
    axios
      .post("/visitorManagement/initVisitor", formdata)
      .then((res) => {
        if (res.data.flag == "YES") {
          this.overlay = false;
          this.logo = res.data.logo;
          this.proceed_flag = true;
        } else {
          this.showSnackbar("red", res.data.snackbar);
          sessionStorage.setItem("error-trace", res.data.error_trace);
          this.overlay = false;
        }
        this.overlay = false;
      })
      .catch((error) => {
        this.onerror(error);
        this.overlay = false;
      })
      .finally(() => {
        this.overlay = false;
        // this.selected_date=""
      });
  },
  methods: {
    validEmail(email) {
      //alert("in valid")
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (re.test(email)) {
        // alert("Please Check Your email id");
        return true;
      }
      return false;
    },
    // validation code
    validName() {
      this.validMob();
      if (/[^a-zA-Z\s]/.test(this.visitor_name)) {
        this.error = "Input value contains other syantax.";
        this.showSnackbar("red", "Input value contains other syantax.");
        // alert("Input value contains other syantax");
        this.name_error = true;
        this.overlay = false;
      } else {
        this.name_error = false;
        this.error = "";
      }
    },

    validMob() {
      var a = document.getElementById("mobilenumber").value;

      if (a.length < 10 || a.length > 10 || isNaN(a) || a == "") {
        this.mob_error1 = "Please Enter Valid Number";

        this.showSnackbar("red", "Please Enter Valid Number");
        this.mob_error = true;
        return false;
      } else {
        this.mob_error = false;
      }
    },

    hasWhiteSpace(s) {
      var status = false;
      var reWhiteSpace = new RegExp(/^\s+$/);

      // Check for white space
      if (reWhiteSpace.test(s)) {
        // alert("Please Check Your Fields For Spaces");
        return true;
      }
      return false;
    },
    reset() {
      // this.save_edit = "Add Myself";
      //   this.edit_io_id = null;
      this.visitor_name = "";
      this.visitor_email = "";
      this.visitor_mobileno = "";
      this.visitor_address = "";
    },
    // validation code end
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    onerror(error) {
      let msg = "";
      if (error.response) {
        msg = "Something went wrong.";
      } else if (error.request) {
        msg = "Please try again.";
      } else {
        msg = "Un-expected error.";
      }
      this.showSnackbar("error", msg);
    },
    ///////////////////////////
    addVisitor() {
      //validation on mobileno and name // mandatory
      this.validName();
      this.validMob();
      if (this.hasWhiteSpace(this.visitor_name) || this.visitor_name == null) {
        this.showSnackbar("#b71c1c", "Please Enter Name");
        return;
      }
      if (this.hasWhiteSpace(this.visitor_email)) {
        this.showSnackbar("#b71c1c", "Please Enter Email ");
        return
      }
      if (this.visitor_email) {

        if (!this.validEmail(this.visitor_email)) {
          this.showSnackbar("#b71c1c", "Please Enter Valid Email");
          return
        }
      }
      const formdata = {
        visitor_address: this.visitor_address,
        visitor_name: this.visitor_name,
        visitor_email: this.visitor_email,
        visitor_mobileno: this.visitor_mobileno,
        o: this.$route.query.o,
        t: this.$route.query.t,
        // save_edit: this.save_edit,
      };
      this.overlay = true;
      axios
        .post("/visitorManagement/addVisitor", formdata)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.overlay = false;
            // this.qrcode = true
            this.showSnackbar("green", "Visitor Added Successfully");
            this.reset();
          } else {
            this.reset();

            //  this.qrcode = false
            this.showSnackbar("red", res.data.snackbar);

            sessionStorage.setItem("error-trace", res.data.error_trace);
            this.overlay = false;
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);
          // this.qrcode = false
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          // this.selected_date=""
        });
    },
    getVisitor() {
      //validation on mobileno and name // mandatory
      this.validMob();

      const formdata = {
        visitor_mobileno: this.visitor_mobileno,
        o: this.$route.query.o,
        t: this.$route.query.t,
      };
      this.overlay = true;
      axios
        .post("/visitorManagement/getVisitor", formdata)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.overlay = false;
            this.visitor_present = true;
            this.visitor_address = res.data.visitor_address;
            this.visitor_email = res.data.visitor_email;
            this.visitor_name = res.data.visitor_name;
            //  this.qrcode = true
            this.showSnackbar("green", res.data.snackbar);
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
            //  this.qrcode = false
            this.overlay = false;
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);
          // this.qrcode = false
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          // this.selected_date=""
        });
    },
  },
};
</script>

<style scoped>
.alert {
  /* padding: 5px 10px; */
  /* border: 1px solid #ff72728a; */
  display: inline-block;
  color: #f30808;
  /* border-radius: 4px; */
}
</style>